"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTypography = exports.StyledSelectedStrategyNodeTitleWrapper = exports.StyledErrorAlert = exports.StyledStrategyAttributesContainer = exports.StyledContainer = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
const components_1 = require("../../components");
exports.StyledContainer = styled_components_1.default.div `
  position: relative;
  display: flex;
  overflow: hidden;

  .loading-overlay {
    position: absolute;
    display: flex;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 10;
  }
`;
exports.StyledStrategyAttributesContainer = styled_components_1.default.div `
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden;
  border: 1 px solid ${ui_components_1.baseColors.primaryGray200};
  box-shadow: ${ui_components_1.shadows.card};
  border-radius: 4px;
  padding: ${({ theme }) => theme.spacing(2)};
  gap: ${({ theme }) => theme.spacing(1)};
  background-color: ${({ theme }) => theme.palette.common.white};

  .attributes-container-enrich-alert {
    margin: ${({ theme }) => theme.spacing(1, 0)};
  }

  .attributes-container-actions {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .MuiButtonBase-root {
      padding-left: 0;
    }
  }

  .attributes-container-filter-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .attributes-container-filter-actions-right {
    display: flex;

    .attributes-clear-button {
      padding: 0;
    }
  }

  .attributes-container-title {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(0.5)};

    .section-title-content {
      display: flex;
      min-width: 100px;
      gap: ${({ theme }) => theme.spacing(0.5)};
      align-items: center;
      justify-content: flex-start;
    }

    & .attributes-collapse-button {
      white-space: nowrap;

      &.MuiButton-text {
        text-transform: capitalize;
        font-weight: 400;

        &:hover {
          background-color: transparent;
        }
      }
    }

    .attributes-collapse-button {
      .icon-wrapper-class {
        font-size: 1rem;
      }

      svg {
        transform: rotate(90deg);
      }

      &.attributes-collapse-button--expand-all {
        svg {
          transform: rotate(-90deg);
        }
      }
    }

    .selected-strategy-node-title {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      margin-left: ${({ theme }) => theme.spacing(1)};
    }
  }

  .attributes-container-content {
    display: flex;
    flex-direction: column;
    overflow: auto;
    overflow-x: hidden;
    gap: ${({ theme }) => theme.spacing(1)};

    .MuiAccordion-root {
      &::before {
        display: none;
      }

      border-radius: 4px;
      box-shadow: none;
    }

    .load-more-indicator {
      padding: ${({ theme }) => theme.spacing(1)};
    }
  }
`;
exports.StyledErrorAlert = (0, styled_components_1.default)(components_1.Alert) `
  align-self: flex-start;
`;
exports.StyledSelectedStrategyNodeTitleWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
`;
exports.StyledTypography = (0, styled_components_1.default)(ui_components_1.Typography) `
  font-size: 0.875rem;

  .section-title-tooltip-guideline {
    font-size: 0.75rem;
    color: ${ui_components_1.baseColors.background200};
  }
`;
